module.exports = __webpack_public_path__ + "static/media/newarrival-1.4930e301.jpg";